import FormField from '../../other/Input/Field';

const OccupationField = field => (
  <div tabIndex="0">
    <FormField label="Stilling/Yrke" {...field} />
  </div>
);

export default OccupationField;
